// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.downloadApp_downloadButton__rGUCk {
  width: 100%;
  max-width: 296px;
  height: 56px;
  background: #ffffff;
  border-radius: 16px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  padding: 0 24px;
}

.downloadApp_downloadButton__rGUCk:hover {
  transform: translateY(-2px);
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.2);
}

.downloadApp_downloadButton__rGUCk:active {
  transform: translateY(0);
}

.downloadApp_downloadIcon__bFNtQ {
  width: 24px;
  height: 24px;
  color: #0d0e11;
  flex-shrink: 0;
}

.downloadApp_downloadButtonText__BOHYd {
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  color: #0d0e11;
}

.downloadApp_redirectingContainer__7tdiZ {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 160px;
}

.downloadApp_redirectingText__DALWu {
  font-family: 'Noto Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #9396a3;
  margin: 0;
  text-align: center;
  white-space: pre-wrap;
}

.downloadApp_progressBarContainer__fptDq {
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.downloadApp_progressBar__b\\+gkW {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #ffffff;
  border-radius: 10px;
  transition: width 0.1s linear;
}

`, "",{"version":3,"sources":["webpack://./src/components/DownloadApp/downloadApp.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":[".downloadButton {\n  width: 100%;\n  max-width: 296px;\n  height: 56px;\n  background: #ffffff;\n  border-radius: 16px;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 0 24px;\n}\n\n.downloadButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.2);\n}\n\n.downloadButton:active {\n  transform: translateY(0);\n}\n\n.downloadIcon {\n  width: 24px;\n  height: 24px;\n  color: #0d0e11;\n  flex-shrink: 0;\n}\n\n.downloadButtonText {\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #0d0e11;\n}\n\n.redirectingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  width: 160px;\n}\n\n.redirectingText {\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #9396a3;\n  margin: 0;\n  text-align: center;\n  white-space: pre-wrap;\n}\n\n.progressBarContainer {\n  width: 100%;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progressBar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background: #ffffff;\n  border-radius: 10px;\n  transition: width 0.1s linear;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"downloadButton": `downloadApp_downloadButton__rGUCk`,
	"downloadIcon": `downloadApp_downloadIcon__bFNtQ`,
	"downloadButtonText": `downloadApp_downloadButtonText__BOHYd`,
	"redirectingContainer": `downloadApp_redirectingContainer__7tdiZ`,
	"redirectingText": `downloadApp_redirectingText__DALWu`,
	"progressBarContainer": `downloadApp_progressBarContainer__fptDq`,
	"progressBar": `downloadApp_progressBar__b+gkW`
};
export default ___CSS_LOADER_EXPORT___;
